import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getSeoForPath, SITE_URL } from '../utils/seoConfig';

const setMeta = (selector, attribute, name, content) => {
  if (!content) return;

  let element = document.querySelector(`meta[${attribute}="${name}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, name);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
};

const setLink = (rel, href) => {
  if (!href) return;

  let element = document.querySelector(`link[rel="${rel}"]`);
  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', rel);
    document.head.appendChild(element);
  }
  element.setAttribute('href', href);
};

const SEO = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const seo = getSeoForPath(pathname);
    const canonical = `${SITE_URL}${pathname === '/' ? '' : pathname}`;

    document.title = seo.title;
    document.documentElement.lang = 'fr';

    setMeta('meta', 'name', 'description', seo.description);
    setMeta('meta', 'name', 'keywords', seo.keywords);
    setMeta('meta', 'name', 'robots', 'index, follow, max-image-preview:large');
    setMeta('meta', 'name', 'author', 'Chantilly Club');
    setMeta('meta', 'name', 'geo.region', 'FR-59');
    setMeta('meta', 'name', 'geo.placename', 'Villeneuve-d\'Ascq');
    setLink('canonical', canonical);

    setMeta('meta', 'property', 'og:title', seo.title);
    setMeta('meta', 'property', 'og:description', seo.description);
    setMeta('meta', 'property', 'og:url', canonical);
    setMeta('meta', 'property', 'og:type', 'website');
    setMeta('meta', 'property', 'og:locale', 'fr_FR');
    setMeta('meta', 'property', 'og:site_name', 'Chantilly Club');
    setMeta('meta', 'property', 'og:image', seo.image);

    setMeta('meta', 'name', 'twitter:card', 'summary_large_image');
    setMeta('meta', 'name', 'twitter:title', seo.title);
    setMeta('meta', 'name', 'twitter:description', seo.description);
    setMeta('meta', 'name', 'twitter:image', seo.image);

    const scriptId = 'chantilly-club-jsonld';
    let script = document.getElementById(scriptId);
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(seo.jsonLd);
  }, [pathname]);

  return null;
};

export default SEO;
